module.exports = __webpack_public_path__ + "static/media/gpw.14c290e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/gpw.jpg
// module id = 1675
// module chunks = 0